// ContentItem interface to define the structure of content items
export interface ContentItem {
  id: number;
  contentTitle: string;
  contentType: string;
  contentTypeId?: number;
  contentDescription: string;
  uploadThumbnailUrl: string;
  coverPhotoUrl: string;
  duration: string;
  isLike: boolean;
  isBookmarked: boolean;
  viewCount: number;
  like_count: number;
  shareCount: number;
  title?: string;
  contentGenreId?: number;
  genres?: string[];
  docId?: any;
  previewDeepLink?: any;
  publishedDate?: string;
  deepLinkCode?: string;
  consolidatedModule?: string;
}

// Helper function to map API response to ContentItem
export const mapApiResponseToContentItem = (doc: any): ContentItem => {
  return {
    id: doc.id,
    docId: doc.docId,
    contentTitle: doc.title || doc.contentTitle || "",
    contentType: Array.isArray(doc.contentFormat) ? doc.contentFormat[0] || "documents" : doc.contentFormat || doc.contentTypeName || doc.contentType || "documents",
    contentTypeId: doc.contentTypeId,
    contentDescription: doc.description || doc.contentDescription || "",
    uploadThumbnailUrl: doc.thumbnailUrl || doc.uploadThumbnailUrl || "",
    coverPhotoUrl: doc.coverImageUrl || doc.coverPhotoUrl || "",
    duration: doc.duration || "00:00:00",
    isLike: doc.isLike || false,
    isBookmarked: doc.isBookmarked || doc.isBookmark || false,
    viewCount: doc.viewCount || 0,
    like_count: doc.like_count || 0,
    shareCount: doc.shareCount || 0,
    contentGenreId: doc.contentGenreId,
    genres: doc.contentGenreName ? [doc.contentGenreName] : doc.genres || [],
    publishedDate: doc.publishedDate,
    deepLinkCode: doc.deepLinkCode,
    consolidatedModule: doc.consolidatedModule,
  };
};
